import { getQuizReport } from '@/API/repositories/reports';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useState } from 'react';

const useQuizReport = () => {
	const { addMessage } = useMessageQueueContext();
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const [data, setData] = useState();

	const isLoading = hasUnfilledRequest(getQuizReport);

	const fetchQuizReportData = async (
		dateFrom,
		dateTo,
		domain,
		device,
		source,
	) => {
		if (device === 'all') {
			device = undefined;
		}
		if (source === 'all') {
			source = undefined;
		}
		const payload = {
			startDay: dateFrom,
			endDay: dateTo,
			domain,
			device,
			source,
		};

		const response = await makeRequest(getQuizReport.bind(null, payload));

		if (!response.data) {
			return addMessage('Something went wrong', 'error');
		}
		setData(response.data);
	};

	return {
		fetchQuizReportData,
		isLoading,
		data,
	};
};

export default useQuizReport;
